document.addEventListener('DOMContentLoaded', () => {
    const stageContentEl = document.querySelectorAll('.module-stage-content');

    if (!stageContentEl) {
        return;
    }

    stageContentEl.forEach((stageContent) => {
        const parallaxImage = stageContent.querySelector('.parallax-image img');

        if (parallaxImage) {
            new simpleParallax(parallaxImage, {
                overflow: false,
                orientation: 'up',
                scale: 1.1, // Increase scale for a more noticeable effect
                delay: 3,
            });
        }
    });
});
